<template>
  <div>
    <transition name="bounce">
      <div v-if="releaseUpdated || subscriptionUpdated" class="update-notification">
        <div class="d-flex align-items-center">
          <div class="d-flex flex-column">
            <div v-if="releaseUpdated" class="update-text">
              <h6 class="mb-0 font-weight-midbold">{{ $t(isImportant ? 'extra.new_important_release' : 'extra.new_release') }}</h6>
              <div v-if="isImportant">
                {{ $t('extra.new_release_description') }} <b>{{ secondsBeforeRefresh }} sek. </b>
                <template v-if="willDataBeSaved">{{ $t('extra.info_will_be_saved') }}</template>
              </div>
            </div>

            <template v-if="subscriptionUpdated">
              <div class="font-weight-midbold">
                {{ $t('extra.plan_renewed') }}
              </div>
            </template>
          </div>

          <s-button class="update-btn-black ml-2" @click="reloadPage">
            <refresh-icon class="text-white"/>
            <span class="font-weight-midbold">{{ $t('actions.update') }}</span>
          </s-button>
        </div>

        <progress-bar v-if="isImportant" @end="reloadPage" :animation-duration="secondsBeforeRefresh" class="mt-2"/>
      </div>
    </transition>
  </div>
</template>
<script>
  import RefreshIcon from '@/components/icons/refresh';
  import ProgressBar from '@/components/progress/progress';
  import { routerService } from '@/core';
  import { useUpdateStore } from '@/stores/update';
  import { useAuthStore } from '@/stores/auth';

  export default {
    name: 'UpdateNotification',
    components: { ProgressBar, RefreshIcon },

    data() {
      return {
        secondsBeforeRefresh: 60,
        updateStore: useUpdateStore(),
        authStore: useAuthStore(),
      };
    },
    computed: {
      isImportant() {
        return this.updateStore.refresh_version_mismatch;
      },

      subscriptionUpdated() {
        return this.authStore.subscription_mismatch;
      },

      releaseUpdated() {
        return this.updateStore.mismatch || this.updateStore.refresh_version_mismatch;
      },

      willDataBeSaved() {
        return routerService.current.name === 'invoice.create';
      },
    },

    methods: {
      reloadPage() {
        if (routerService.current.name === 'invoice.create') {
          window.location.replace(this.$router.resolve({ name: 'invoice.index' }).href);
        } else {
          window.location.reload();
        }
      },
    },
  };
</script>
